import React, { FunctionComponent } from 'react';
import { Grid, Typography } from '@rbx/ui';
import TreeNode from '../interfaces/TreeNode';
import Tree, { SingleSelectTreeViewState } from './Tree';
import useSideBarNavigationStyles from './SideBarNavigation.styles';

export interface TreeListProps extends SingleSelectTreeViewState {
  heading: string | null;
  treeNodes: TreeNode[];
  expanded: string[];
  setExpanded: React.Dispatch<React.SetStateAction<string[]>>;
  setSelected: React.Dispatch<React.SetStateAction<string>>;
  headingClassName?: string;
  treeClassName?: string;
  className?: string;
}

const TreeList: FunctionComponent<React.PropsWithChildren<TreeListProps>> = ({
  expanded,
  selected,
  setExpanded,
  setSelected,
  heading,
  treeNodes,
  headingClassName,
  treeClassName,
  className,
}) => {
  const {
    classes: { navigationHeading },

    cx,
  } = useSideBarNavigationStyles();

  return (
    <Grid container direction='column' wrap='nowrap' className={className}>
      {heading && (
        <Typography
          className={cx(navigationHeading, headingClassName)}
          variant='overline'
          color='secondary'>
          {heading}
        </Typography>
      )}
      {treeNodes.map((treeNode, idx) => (
        <Tree
          className={treeClassName}
          // eslint-disable-next-line react/no-array-index-key
          key={`${heading}-${idx}`}
          expanded={expanded}
          selected={selected}
          setExpanded={setExpanded}
          setSelected={setSelected}
          tree={treeNode}
        />
      ))}
    </Grid>
  );
};

export default TreeList;
